import { useEffect, useRef, useState } from 'react'
import FooterSection from './sections/FooterSection'
import TimeSection from './sections/TimeSection'
import TopRibon from './sections/TopRibon'
import NavigationBar from './sections/NavigationBar'
import HeroSection from './sections/HeroSection'
import ScriptureSlideShow from './sections/ScriptureSlideShow'
import MediaSection from './sections/MediaSection'
import ReferencesSection from './sections/ReferencesSection'
import BibleSection from './sections/BibleSection'
import LabeledImagesSection from './sections/LabeledImagesSection'
import FeaturedContentSection from './sections/FeaturedContent'
import { useScreenSize } from '../../hooks/useScreenSize'

export default function Home({
  'home_page_data': homePageData,
  'attachment_groups': attachmentGroups
}: any) {
  const { screenLargerThan } = useScreenSize();
  const isLarge = screenLargerThan('lg');
  const [showMobileHeader, setShowMobileHeader] = useState(true);
  const lastScrollY = useRef(0);
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const hideTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  // Hide and show menu
  useEffect(() => {
    if (isLarge) return;

    const container = scrollContainerRef.current;
    if (!container) return;

    const handleScroll = () => {
      const currentScrollY = container.scrollTop;
      const isScrollingUp = currentScrollY < lastScrollY.current;
      const isAtTop = currentScrollY < 10;

      if (isScrollingUp || isAtTop) {
        if (hideTimeoutRef.current) {
          clearTimeout(hideTimeoutRef.current);
          hideTimeoutRef.current = null;
        }
        setShowMobileHeader(true);
      } else {
        if (!hideTimeoutRef.current) {
          hideTimeoutRef.current = setTimeout(() => {
            setShowMobileHeader(false);
            hideTimeoutRef.current = null;
          }, 5000);
        }
      }

      lastScrollY.current = currentScrollY;
    };

    container.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      container.removeEventListener('scroll', handleScroll);
      if (hideTimeoutRef.current) {
        clearTimeout(hideTimeoutRef.current);
      }
    };
  }, [isLarge]);

  return (
    <div
      style={{
        height: '100%',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {isLarge && (
        <>
          <TopRibon
            topRibbon={homePageData?.top_ribbon}
          />
          <NavigationBar
            referencesSections={homePageData?.references_sections}
          />
        </>
      )}
      {!isLarge && (
        <>
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              zIndex: 1000,
              transform: showMobileHeader ? 'translateY(0)' : 'translateY(-100%)',
              transition: 'transform 0.3s ease-in-out',
            }}
          >
            <TopRibon
              topRibbon={homePageData?.top_ribbon}
            />
            <NavigationBar
              referencesSections={homePageData?.references_sections}
            />
          </div>
          {!showMobileHeader && (
            <button
              onClick={() => setShowMobileHeader(true)}
              style={{
                position: 'fixed',
                top: 0,
                left: '50%',
                transform: 'translateX(-50%)',
                zIndex: 999,
                backgroundColor: 'var(--color-neutral)',
                color: 'var(--color-base-300)',
                border: 'none',
                borderRadius: '0 0 8px 8px',
                padding: '4px 20px',
                fontSize: '0.7rem',
                cursor: 'pointer',
                boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
              }}
            >
              ▼ Menu
            </button>
          )}
        </>
      )}
      <div
        ref={scrollContainerRef}
        id="main-scroll-container"
        style={{
          flex: 1,
          overflowX: 'hidden',
          overflowY: 'auto',
        }}
      >
        <ScriptureSlideShow
          slides={homePageData?.scripture_slides}
        />
        <HeroSection
          heroSectionData={homePageData?.hero_section}
          topRibbon={homePageData?.top_ribbon}
        />
        <TimeSection
          announcements={homePageData?.announcements}
        />
        <FeaturedContentSection
          items={homePageData?.featured_content}
        />
        <BibleSection />
        <LabeledImagesSection
          labeledImages={homePageData?.labeled_images}
        />
        <MediaSection
          attachmentGroups={attachmentGroups}
        />
        {/* <SouvenirSection /> */}
        <ReferencesSection
          referencesSections={homePageData?.references_sections}
        />
        <FooterSection
          referencesSections={homePageData?.references_sections}
          topRibbon={homePageData?.top_ribbon}
        />
      </div>
    </div>
  )
}
